<template>
  <!-- 案件委托内容页 -->
  <div id="entrustdet">
    <div class="w12">
      <endetfripro />
      <endetajinfo class="mt20 bgff" />
      <div class="mt30 flexstart between">
        <div class="lef ">
          <endetlawapa class="bgffdow" />
          <endetlawjq class="bgffdow mt30" />
          <endetzxaj class="bgffdow mt30" />
        </div>
        <div class="rig">
          <endetjqlc class="bgffdow" />
          <div class="ajwt mt30"></div>
          <endetyslsadv class="bgffdow mt30" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import endetfripro from "./components/endetfripro";
import endetajinfo from "./child/endetajinfo";
import endetlawapa from "./child/endetlawapa";
import endetlawjq from "./child/endetlawjq";
import endetzxaj from "./child/endetzxaj";
import endetjqlc from "./components/endetjqlc";
import endetyslsadv from "./components/endetyslsadv";

export default {
  name: "entrustdet",
  components: {
    endetfripro,
    endetajinfo,
    endetlawapa,
    endetlawjq,
    endetzxaj,
    endetjqlc,
    endetyslsadv,
  },
};
</script>

<style lang="scss" scoped>
#entrustdet {
  background-color: #f8f8f8;
  .bgff {
    background-color: #fff;
  }
  .w12 {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
  }
  .flexstart {
    align-items: flex-start;
  }
  .bgffdow {
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(1, 1, 1, 0.08);
  }
  .lef {
    width: 840px;
  }
  
  .rig {
    width: 330px;
    .ajwt{
      cursor: pointer;
      width: 330px;
      height: 150px;
      background: url('../../assets/entrust/dsrwtzlsbg.jpg');
    }
  }
}
</style>
